import { library } from "@fortawesome/fontawesome-svg-core";

// Adding Font Awesome Kit
const kitScript = document.createElement("script");
kitScript.setAttribute("src", "https://kit.fontawesome.com/744600aa7c.js");
kitScript.setAttribute("type", "text/javascript");
kitScript.setAttribute("crossorigin", "anonymous");
document.head.appendChild(kitScript);

//import fontawesome6 icons
//free solid icons set
import {
  faEllipsis as faEllipsisSolid,
  faArrowLeft,
  faBan,
  faBolt,
  faCaretDown,
  faCaretUp,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck as faCircleCheckSolid,
  faCircleExclamation as faCircleExclamationSolid,
  faCircleInfo as faCircleInfoSolid,
  faCircleQuestion as faCircleQuestionSolid,
  faCircleUser,
  faClone,
  faCopy,
  faEye,
  faEyeSlash,
  faFilter,
  faMagnifyingGlass,
  faTriangleExclamation as faTriangleExclamationSolid,
  faXmark,
  faStar,
  faBars,
  faThumbtack,
  faRotateLeft,
  faRotateRight,
  faCircle,
  faStarHalfStroke,
  faUser as faUserSolid,
  faHourglass,
  faWifi,
  faGraduationCap,
  faRobot,
} from "@fortawesome/free-solid-svg-icons";
//pro solid icons set
import {
  faArrowDownLeft,
  faArrowsRotate,
  faArrowTrendUp,
  faArrowUpRight,
  faBackward,
  faBell,
  faCartShopping,
  faCirclePhone,
  faCirclePhoneHangup,
  faCirclePlus,
  faCircleX,
  faCreditCardFront,
  faEllipsisVertical,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopeOpenText,
  faForward,
  faImageSlash,
  faLink,
  faLock,
  faMessageDots,
  faMessageSms as faMessageSmsSolid,
  faPause,
  faPen,
  faPhone,
  faPhoneHangup,
  faPhoneSlash,
  faPlay,
  faPlus,
  faPlusLarge,
  faSortDown,
  faSortUp,
  faSparkles,
  faTrashCan,
  faTriangle,
  faHyphen,
  faFire,
  faPeopleGroup,
  faBadgeCheck as faBadgeCheckSolid,
  faAwardSimple,
  faBatteryFull as faBatteryFullSolid,
  faPartyHorn as faPartyHornSolid,
  faSignalBars,
  faHourglassHalf as faHourglassHalfSolid,
  faComments as faCommentsSolid,
  faArrowDown as faArrowDownSolid,
  faArrowUp as faArrowUpSolid,
  faStore as faStoreSolid,
  faBoxOpen as faBoxOpenSolid,
  faBrowser as faBrowserSolid,
  faWandMagicSparkles as faWandMagicSparklesSolid,
  faMinus as faMinusSolid,
} from "@fortawesome/pro-solid-svg-icons";
//pro light icons set
import {
  faCakeCandles,
  faBinoculars,
  faBoxesStacked,
  faBagsShopping,
  faArrowPointer,
  faHandHoldingBox,
  faBullhorn,
  faGift,
  faBrainCircuit,
  faMicrochipAi,
  faCloudCheck as faCloundCheckLight,
  faCloudArrowUp,
  faCloudXmark,
  faPlugCirclePlus as faPlugCirclePlusLight,
  faPlugCircleBolt as faPlugCircleBoltLight,
  faHourglassEnd,
  faRocketLaunch,
  faArrowUpRightFromSquare,
  faBan as faBanLight,
  faBarChart,
  faBoltLightning,
  faBookOpen as faBookOpenLight,
  faBoxArchive,
  faBoxHeart,
  faCaretDown as faCaretDownLight,
  faCartShopping as faCartShoppingLight,
  faBirthdayCake,
  faChartUser,
  faChartMixed,
  faChartPie,
  faCheck as faCheckLight,
  faCheckSquare,
  faCircleCheck as faCircleCheckLight,
  faBagShopping,
  faCircleExclamation,
  faCircleInfo,
  faTags,
  faCirclePause,
  faCirclePlay,
  faCirclePlus as faCirclePlusLight,
  faCircleStar,
  faCircleUser as faCircleUserLight,
  faCircleXmark,
  faClock,
  faClone as faCloneLight,
  faCogs,
  faLockKeyhole,
  faCommentsQuestionCheck,
  faComment as faCommentLight,
  faCopy as faCopyLight,
  faDownload,
  faEnvelope as faEnvelopeLight,
  faEnvelopes,
  faEnvelopesBulk,
  faExternalLink,
  faEye as faEyeLight,
  faEyeSlash as faEyeSlashLight,
  faFileImport,
  faFileExport,
  faFiles,
  faGaugeMax,
  faGear as faGearLight,
  faGlassEmpty as faGlassEmptyLight,
  faHeadphones,
  faHourglassClock,
  faInbox,
  faUserMinus,
  faLightbulb as faLightbulbLight,
  faMagnifyingGlass as faMagnifyingGlassLight,
  faMagnifyingGlassArrowRight,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faMemoCircleInfo,
  faMessageHeart,
  faPaperPlane,
  faPaste,
  faPause as faPauseLight,
  faStop as faStopLight,
  faPen as faPenLight,
  faPaintbrushPencil,
  faPercent,
  faPlus as faPlusLight,
  faRectangleAd,
  faRectanglesMixed,
  faRedo,
  faRoute,
  faShop,
  faSliders,
  faSpinner,
  faSquareDashedCirclePlus,
  faTrashCan as faTrashCanLight,
  faTrash,
  faArrowTrendDown,
  faArrowTrendUp as faArrowTrendUpLight,
  faWebhook,
  faTriangleExclamation,
  faUndo,
  faUpload,
  faUser as faUserLight,
  faKey,
  faUserPlus,
  faUsers,
  faUserTag,
  faVideo,
  faXmark as faXmarkLight,
  faArrowRight,
  faArrowLeft as faArrowLeftLight,
  faOctagonExclamation as faOctagonExclamationLight,
  faMessageDots as faMessageDotsLight,
  faChevronDown as faChevronDownLight,
  faChevronLeft as faChevronLeftLight,
  faChevronRight as faChevronRightLight,
  faChevronUp as faChevronUpLight,
  faClockRotateLeft,
  faLink as faLinkLight,
  faArrowDownLong as faArrowDownLongLight,
  faArrowUpLong as faArrowUpLongLight,
  faWandMagicSparkles,
  faBoxOpen,
  faBoxDollar,
  faCalendar,
  faLifeRing,
  faArrowUpRightFromSquare as faArrowUpRightFromSquareLight,
  faArrowRotateRight as faArrowRotateRightLight,
  faBars as faBarsLight,
  faBarsFilter,
  faCoins,
  faUsersGear,
  faArrowRightToArc,
  faVolumeXmark,
  faVolume,
  faShareNodes,
  faNoteSticky,
  faStar as faStarLight,
  faMessages,
  faEllipsisVertical as faEllipsisVerticalLight,
  faCircleQuestion as faCircleQuestionLight,
  faArrowUpRight as faArrowUpRightLight,
  faListUl,
  faImage,
  faText,
  faUserSlash,
  faUserClock,
  faMessageSlash,
  faDiagramCells,
  faSnooze,
  faPlug,
  faEllipsis,
  faMessageCheck,
  faUserCheck,
  faRectangleVerticalHistory,
  faPaperclip,
  faIcons,
  faArrowDownToLine,
  faUserXmark,
  faSackDollar,
  faCartArrowDown,
  faEnvelopeDot,
  faBullseyePointer,
  faBullseye,
  faPartyHorn,
  faEnvelopeOpen as faEnvelopeOpenLight,
  faEnvelopeCircleCheck,
  faCommentSms,
  faMessageSms as faMessageSmsLight,
  faMessageArrowUp,
  faRocket,
  faBroomWide,
  faMessagePlus,
  faEnvelopeOpenText as faEnvelopeOpenTextLight,
  faMobile,
  faGrid2,
  faTableList,
  faCamera,
  faMicrophoneLines,
  faArrowsRotate as faArrowsRotateLight,
  faImageSlash as faImageSlashLight,
  faBell as faBellLight,
  faFaceSleeping,
  faMailbox,
  faMessageLines,
  faCreditCardFront as faCreditCardFrontLight,
  faPalette,
  faBlockBrick,
  faScrewdriverWrench,
  faUsersRectangle,
  faWallet,
  faBrowsers,
  faBrowser,
  faFileInvoiceDollar,
  faAnglesUpDown,
  faLightbulbExclamation,
  faThumbTack,
  faMegaphone,
  faBoxesPacking,
  faTag,
  faAt,
  faArrowRightFromBracket,
  faMinus,
  faCircle as faCircleLight,
  faCircleDashed,
  faHome,
  faSplit,
  faWindowRestore,
  faWindowClose,
  faChartLineUp,
  faAnglesRight,
  faLock as faLockLight,
  faPenToSquare,
  faCaretRight,
  faUserMagnifyingGlass,
  faSlashForward,
  faArrowUpToLine,
  faBolt as faBoltLight,
  faDatabase,
  faInfinity,
  faBadgePercent,
  faBadgeDollar,
  faBadgeCheck,
  faLoader,
  faCalendarClock,
  faArrowDownToSquare,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faExpand,
  faCompress,
  faArrowRotateRight,
  faBug,
  faPlay as faPlayLight,
  faToggleLargeOn,
  faStarShooting,
  faHandWave,
  faFire as faFireLight,
  faMessageSms,
  faDesktop,
  faMobileAndroid,
  faChartLine,
  faSatelliteDish,
  faLockOpen,
  faArrowUp,
  faVialCircleCheck,
  faPhone as faPhoneLight,
  faPhoneArrowDownLeft,
  faPencil,
  faPuzzlePiece,
  faTimer,
  faPlugCircleCheck,
  faGlobe,
  faList,
  faGlassEmpty,
  faLayerGroup,
  faFilterCircleXmark,
  faFloppyDisk,
  faDollarSign,
  faArrowTurnLeft,
  faArrowUpShortWide,
  faArrowUpWideShort,
  faArrowDownShortWide,
  faLightbulbOn,
  faArrowDownWideShort,
  faSparkles as faSparklesLight,
  faArrowDown as faArrowDownLight,
  faThumbsUp,
  faThumbsDown,
  faFileSpreadsheet,
  faComment,
  faBox,
  faStore,
  faRotateRight as faRotateRightLight,
  faFlagCheckered,
  faReply,
  faBadge,
  faSidebar,
  faFont,
} from "@fortawesome/pro-light-svg-icons";
//pro regular icons set
import {
  faBookOpen,
  faMessageSms as faMessageSmsRegular,
  faGear,
  faListUl as faListUlRegular,
  faSpinnerThird,
  faCircleCheck as faCircleCheckRegular,
  faEllipsisVertical as faEllipsisVerticalRegular,
  faEllipsisStroke,
  faBracketsCurly,
  faTv,
  faUser,
  faCode,
  faHandPointer,
  faCalendar as faCalendarRegular,
  faHouse,
  faArrowTrendUp as faArrowTrendUpRegular,
  faStar as faStarRegular,
  faHourglassStart,
  faTimelineArrow,
  faCartShopping as faCartShoppingRegular,
  faBatteryFull,
  faCaretDown as faCaretDownRegular,
  faCaretUp as faCaretUpRegular,
} from "@fortawesome/pro-regular-svg-icons";
//free brands icons set
import { faWhatsapp, faFacebookMessenger, faDev, faGoogle } from "@fortawesome/free-brands-svg-icons";

import {
  faCircleXmark as faCircleXmarkRegular,
  faEnvelope as faEnvelopeFreeRegular,
  faWindowRestore as faWindowRestoreRegular,
  faHourglassHalf as faHourglassHalfRegular,
} from "@fortawesome/free-regular-svg-icons";

library.add(faCircleXmarkRegular, faEnvelopeFreeRegular);

// import Vue from "vue";

library.add(
  faArrowDownLight,
  faFilterCircleXmark,
  faCaretDownRegular,
  faCaretUpRegular,
  faHourglassHalfRegular,
  faWindowRestoreRegular,
  faCartShoppingRegular,
  faPartyHornSolid,
  // @ts-ignore
  faTimelineArrow,
  faChevronDown,
  faBracketsCurly,
  faTv,
  faUser,
  faCode,
  faHandPointer,
  faCalendarRegular,
  faHouse,
  faEllipsisVerticalRegular,
  faListUl,
  faArrowUpRightLight,
  faListUlRegular,
  faImage,
  faText,
  faPlugCirclePlusLight,
  faPlugCircleBoltLight,
  faRocketLaunch,
  faWhatsapp,
  faFacebookMessenger,
  faGoogle,
  faArrowDownLongLight,
  faArrowUpLongLight,
  faCircleCheckRegular,
  faSpinnerThird,
  faChevronUp,
  faCaretDown,
  faCaretUp,
  faBullhorn,
  faChevronLeft,
  faChevronRight,
  faCheck,
  faXmark,
  faCloundCheckLight,
  faCloudArrowUp,
  faCloudXmark,
  faMagnifyingGlass,
  faCircleQuestionSolid,
  faFilter,
  faEye,
  faEyeSlash,
  faCircleExclamationSolid,
  faCircleCheckSolid,
  faCircleInfoSolid,
  faTriangleExclamationSolid,
  faCircleUser,
  faCopy,
  faClone,
  faBan,
  faEllipsisVertical,
  faArrowLeft,
  faTriangle,
  faEllipsisVerticalLight,
  faCircleX,
  faMessageDots,
  faTrashCan,
  faWebhook,
  faPlus,
  faPlusLarge,
  faCirclePlus,
  faPen,
  faPenToSquare,
  faLockKeyhole,
  faLink,
  faEnvelope,
  faTags,
  faEnvelopeOpen,
  faEnvelopeOpenText,
  faCreditCardFront,
  faBell,
  faLock,
  faForward,
  faBackward,
  faPlay,
  faPause,
  faVolume,
  faCirclePhone,
  faCirclePhoneHangup,
  faPhone,
  faBug,
  faPhoneHangup,
  faPhoneSlash,
  faArrowDownLeft,
  faArrowUpRight,
  faArrowTrendUp,
  faSortUp,
  faSortDown,
  faCartShopping,
  faImageSlash,
  faArrowsRotate,
  faCircleInfo,
  faTriangleExclamation,
  faCirclePlay,
  faCirclePause,
  faCircleCheckLight,
  faBagShopping,
  faCircleXmark,
  faCircleStar,
  faCircleExclamation,
  faPercent,
  faBookOpenLight,
  faVideo,
  faEyeLight,
  faEyeSlashLight,
  faCommentsQuestionCheck,
  faComment,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faSliders,
  faChartUser,
  faChartMixed,
  faMessageHeart,
  faEnvelopesBulk,
  faUsers,
  faRotateLeft,
  faRotateRight,
  faRotateRightLight,
  faFlagCheckered,
  faHourglassClock,
  faMagnifyingGlassArrowRight,
  faPenLight,
  faPaintbrushPencil,
  faBolt,
  faBoltLightning,
  faClock,
  faRobot,
  faCopyLight,
  faCloneLight,
  faPaste,
  faTrashCanLight,
  faTrash,
  faArrowTrendDown,
  faArrowTrendUpLight,
  faBoxHeart,
  faCaretDownLight,
  faCartShoppingLight,
  faBirthdayCake,
  faShop,
  faArrowPointer,
  faUserPlus,
  faUserTag,
  faCirclePlusLight,
  faSpinner,
  faGearLight,
  faGlassEmptyLight,
  faBanLight,
  faRectangleAd,
  faRoute,
  faCogs,
  faBarChart,
  faCheckSquare,
  faPaperPlane,
  faHeadphones,
  faGaugeMax,
  faEnvelopeLight,
  faCircleUserLight,
  faUserLight,
  faKey,
  faExternalLink,
  faUndo,
  faRedo,
  faBookOpen,
  faGear,
  faUserMinus,
  faLightbulbLight,
  faUpload,
  faFileImport,
  faFileExport,
  faFiles,
  faInbox,
  faArrowUpRightFromSquare,
  faRectanglesMixed,
  faSquareDashedCirclePlus,
  faPauseLight,
  faStopLight,
  faMagnifyingGlassLight,
  faMemoCircleInfo,
  faBoxArchive,
  faEnvelopes,
  faXmarkLight,
  faDownload,
  faPlusLight,
  faCheckLight,
  faArrowRight,
  faArrowLeftLight,
  faOctagonExclamationLight,
  faMessageDotsLight,
  faChevronDownLight,
  faChevronLeftLight,
  faChevronRightLight,
  faChevronUpLight,
  faClockRotateLeft,
  faLinkLight,
  faInfinity,
  faWandMagicSparkles,
  faBoxOpen,
  faBoxDollar,
  faCalendar,
  faHyphen,
  faLifeRing,
  faArrowUpRightFromSquareLight,
  faArrowRotateRightLight,
  faBarsLight,
  faBarsFilter,
  faCoins,
  faUsersGear,
  faArrowRightToArc,
  faVolumeXmark,
  faShareNodes,
  faNoteSticky,
  faCircleQuestionLight,
  faArrowRightToArc,
  faStar,
  faStarLight,
  faMessages,
  faUserSlash,
  faUserClock,
  faBars,
  faMessageSlash,
  faDiagramCells,
  faSnooze,
  faPlug,
  faEllipsis,
  faMessageCheck,
  faUserCheck,
  faSnooze,
  faRectangleVerticalHistory,
  faPaperclip,
  faIcons,
  faArrowDownToLine,
  faUserXmark,
  faThumbtack,
  faScrewdriverWrench,
  faSackDollar,
  faCartArrowDown,
  faEnvelopeDot,
  faBullseyePointer,
  faBullseye,
  faPartyHorn,
  faEnvelopeOpenLight,
  faEnvelopeCircleCheck,
  faCommentSms,
  faMessageSms,
  faMessageArrowUp,
  faRocket,
  faBroomWide,
  faMessagePlus,
  faEnvelopeOpenTextLight,
  faEllipsisStroke,
  faMobile,
  faGrid2,
  faTableList,
  faCamera,
  faMicrophoneLines,
  faArrowsRotateLight,
  faImageSlashLight,
  faBellLight,
  faMessageLines,
  faFaceSleeping,
  faMailbox,
  faCreditCardFrontLight,
  faPalette,
  faBlockBrick,
  faUsersRectangle,
  faWallet,
  faBrowser,
  faFileInvoiceDollar,
  faBrowsers,
  faAnglesUpDown,
  faGlassEmpty,
  faLightbulbExclamation,
  faThumbTack,
  faMegaphone,
  faBoxesPacking,
  faTag,
  faAt,
  faArrowRightFromBracket,
  faMinus,
  faCircleLight,
  faCircle,
  faCircleDashed,
  faHome,
  faSplit,
  faWindowRestore,
  faWindowClose,
  faChartLineUp,
  faAnglesRight,
  faLockLight,
  faDev,
  faCaretRight,
  faUserMagnifyingGlass,
  faSlashForward,
  faArrowUpToLine,
  faSparkles,
  faBoltLight,
  faDatabase,
  faBadgePercent,
  faBadgeDollar,
  faBadgeCheck,
  faLoader,
  faChartPie,
  faCalendarClock,
  faArrowDownToSquare,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faExpand,
  faCompress,
  faArrowRotateRight,
  faPlayLight,
  faArrowTrendUpRegular,
  faToggleLargeOn,
  faStarRegular,
  faStarHalfStroke,
  faStarShooting,
  faHandWave,
  faFire,
  faFireLight,
  faMessageSmsLight,
  faMessageSms,
  faMessageSmsSolid,
  faDesktop,
  faMobileAndroid,
  faChartLine,
  faUserSolid,
  faSatelliteDish,
  faPeopleGroup,
  faBadgeCheckSolid,
  faAwardSimple,
  faGift,
  faLockOpen,
  faArrowUp,
  faVialCircleCheck,
  faArrowUp,
  faPhoneLight,
  faPencil,
  faHourglassStart,
  faHourglassEnd,
  faHourglass,
  faMessageSmsRegular,
  faPuzzlePiece,
  faTimer,
  faPlugCircleCheck,
  faEllipsisSolid,
  faGlobe,
  faList,
  faSignalBars,
  faWifi,
  faBatteryFull,
  faBatteryFullSolid,
  faLayerGroup,
  faFloppyDisk,
  faArrowTurnLeft,
  faDollarSign,
  faArrowUpShortWide,
  faLightbulbOn,
  faArrowUpWideShort,
  faArrowDownShortWide,
  faArrowDownWideShort,
  faSparklesLight,
  faThumbsUp,
  faThumbsDown,
  faFileSpreadsheet,
  faBrowserSolid,
  faWandMagicSparklesSolid,
  faHourglassHalfSolid,
  faCommentsSolid,
  faArrowDownSolid,
  faArrowUpSolid,
  faStoreSolid,
  faBoxOpenSolid,
  faComment,
  faCommentLight,
  faBox,
  faStore,
  faMinusSolid,
  faReply,
  faBadge,
  faGraduationCap,
  faBrainCircuit,
  faMicrochipAi,
  faSidebar,
  faCakeCandles,
  faBinoculars,
  faBoxesStacked,
  faBagsShopping,
  faHandHoldingBox,
  faPhoneArrowDownLeft,
  faFont
);
